export default __webpack_public_path__ + "static/media/INNOVACION.54bf22d7.jpg";